import { createComponent } from '@lit/react'
import * as React from 'react'

import Component from '../../components/form/form-label/form-label.component.js'

const tagName = 'dap-ds-form-label'

/**
 * `dap-ds-form-label`
 * @summary A form label is a container for labels in a form.
 * @element dap-ds-form-label
 * @title - Form label
 * @group form
 *
 * @property {string} optionalLabel - Label of optional text
 * @property {boolean} subtle - Text weight of the label.
 * @property {boolean} optional - If the label is optional.
 * @property {boolean} required - If the label is required.
 * @property {string} label - The label text.
 *
 * @csspart base - The main form label container.
 * @csspart required - The required indicator of the form label.
 * @csspart optional - The optional indicator of the form label.
 *
 * @cssproperty --dds-form-label-font-weight - Font weight of the label. Defaults to var(--dds-font-weight-bold).
 * @cssproperty --dds-form-label-line-height - Line height of the label. Defaults to var(--dds-font-line-height-xlarge).
 * @cssproperty --dds-form-label-color - Text color of the label. Defaults to var(--dds-text-neutral-enabled).
 * @cssproperty --dds-form-label-disabled-color - Text color when the label is disabled. Defaults to var(--dds-text-neutral-disabled).
 * @cssproperty --dds-form-label-required-color - Color of the required indicator. Defaults to var(--dds-text-negative-subtle).
 * @cssproperty --dds-form-label-optional-color - Color of the optional indicator. Defaults to var(--dds-text-neutral-subtle).
 * @cssproperty --dds-form-label-margin-bottom - Bottom margin of the label. Defaults to var(--dds-spacing-200).
 */
const reactWrapper = createComponent({
  tagName,
  elementClass: Component,
  react: React,
  events: {},
  displayName: 'DapDSFormLabel',
})

export default reactWrapper
